import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {FormGroup, Input, Label} from "reactstrap"

class FilterInput extends Component {
    _handleChangeInput = (e) => {
        const {name, value} = e.target
        const {onChange} = this.props

        if (typeof onChange === 'function') {
            onChange(name, value)
        }
    }

    render() {
        const {value, name, label, type, error, disabled = false} = this.props

        return (
            <FormGroup>
                <Label>{label}</Label>
                <Input className={error ? 'error' : ''} type={type} name={name} value={value} disabled={disabled}
                       onChange={this._handleChangeInput}/>
            </FormGroup>
        )
    }
}

FilterInput.propTypes = {
    error: PropTypes.any,
    type: PropTypes.string.isRequired,
    value: PropTypes.any,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
}

export default FilterInput
